import cefBridge from "./dotnetAdapter";

/**
 * @type {import('@module-system').IModule}
 */
var module = {
  name: "ExternalAdapter",
  version: "1.0.0",
  register() {
    window.cefBridge = cefBridge;
  },
};
export default module;
